import React, { Component } from 'react';

import {Call} from './shared/Icons';
import { FormattedMessage } from 'react-intl';

class ClientIncomingCall extends Component {
  render() {
    return (
      <div className="incomingCall frosted">
        <div className="caller">
          <div>
            <FormattedMessage
              id='Client.ClientIncomingCall.IncomingVideoCall'
              defaultMessage='Video-Anruf von {name}'
              values={{
                name: <div><span className="name">{this.props.caller.name}</span></div>
              }} />
          </div>
        </div>
        <div className={"actions"}>
          <div>
            <div
              className="endCall roundIcon"
              onClick={this.props.onDeny}
            >
              <Call />
            </div>
            <span>
              <FormattedMessage
                id='Client.ClientIncomingCall.Deny'
                defaultMessage='Ablehnen'
               />
            </span>
          </div>
          <div>
            <div
              className="call roundIcon"
              onClick={this.props.onAccept}
              style={{
                backgroundColor: 'rgb(0, 200, 83)'
              }}
            >
              <Call style={{fill:'white'}}/>
            </div>
            <span>
              <FormattedMessage
                id='Client.ClientIncomingCall.Accept'
                defaultMessage='Annehmen'
               /></span>
          </div>
        </div>
      </div>
    );
  }
};

export default ClientIncomingCall;


// WEBPACK FOOTER //
// ./src/ClientIncomingCall.js